import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Row, Col } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { updateUser } from '../ProfileServices';
import { resolveBackendMessage } from '../../../Utils/apiMessages';
import { useErrorHandler } from '../../../Hooks/useErrorHandler';
import ResponsiveModal from '../../Shared/ResponsiveModal/ResponsiveModal';

const ChangePassword = ({ handleClose }) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { handleError } = useErrorHandler();

    const onFinish = async (values) => {
        try {
            setLoading(true);
            // Add your API call here to update the password
            const payload = await updateUser({
                "old_password": form.getFieldValue('currentPassword'),
                "new_password": form.getFieldValue('newPassword'),
            });

            {
                const text = resolveBackendMessage(t, payload);
                if (text) message.success(text);
            }
            form.resetFields();
            handleClose();
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <ResponsiveModal
            title={t('change_password')}
            footer={
                <Button
                    type="primary"
                    loading={loading}
                    onClick={() => form.submit()}
                    block
                >
                    {t('update_password')}
                </Button>
            }
            open
            onCancel={handleClose}
            desktopWidth={500}
        >
            <Row>
                <Col xs={24} >
                    <Form
                        form={form}
                        name="change_password"
                        layout="vertical"
                        requiredMark="optional"
                    >
                        <Form.Item
                            name="currentPassword"
                            label={t('current_password')}
                            rules={[
                                {
                                    required: true,
                                    message: t('please_input_your_current_password'),
                                },
                            ]}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder={t('enter_your_current_password')}
                            />
                        </Form.Item>

                        <Form.Item
                            name="newPassword"
                            label={t('new_password')}
                            rules={[
                                {
                                    required: true,
                                    message: t('please_input_your_new_password'),
                                },
                                {
                                    min: 8,
                                    message: t('password_must_be_at_least_8_characters'),
                                },
                                {
                                    pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/,
                                    message: t('password_must_contain_both_letters_and_numbers'),
                                },
                            ]}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder={t('enter_your_new_password')}
                            />
                        </Form.Item>

                        <Form.Item
                            name="confirmPassword"
                            label={t('confirm_new_password')}
                            dependencies={['newPassword']}
                            rules={[
                                {
                                    required: true,
                                    message: t('please_confirm_your_password'),
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('newPassword') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error(t('the_two_passwords_do_not_match'))
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder={t('confirm_your_new_password')}
                            />
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </ResponsiveModal>
    );
};

export default ChangePassword;
